import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import BestSellersSection from './components/BestSellersSection';
import CategorySection from './components/CategorySection';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import ModularSection from './components/ModularSection';
import { Toaster } from './components/ui/sonner';
import { toast } from 'sonner';
import {
  bestSellers,
  porti,
  garduri,
  mobilier,
  pergole,
  umbrele,
  depozitare,
  decking,
  portfolio,
  pieseModulare,
  feronerie,
  portiLaComanda,
  panouriLaser
} from './mock';
import { ArrowRight } from 'lucide-react';

function App() {
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const cartCount = cart.reduce((s, it) => s + it.qty, 0);

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((p) => p.id === product.id);
      if (existing) {
        return prev.map((p) => (p.id === product.id ? { ...p, qty: p.qty + 1 } : p));
      }
      return [...prev, { ...product, qty: 1 }];
    });
    toast.success('Adăugat în coș', {
      description: product.name.length > 60 ? product.name.slice(0, 60) + '...' : product.name,
      action: {
        label: 'Vezi coșul',
        onClick: () => setCartOpen(true)
      }
    });
  };

  const updateQty = (id, qty) => {
    setCart((prev) => prev.map((p) => (p.id === id ? { ...p, qty } : p)));
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((p) => p.id !== id));
  };

  const clearCart = () => setCart([]);

  return (
    <div className="App bg-white min-h-screen">
      <Header cartCount={cartCount} onCartClick={() => setCartOpen(true)} />

      <main>
        <HeroCarousel />

        <BestSellersSection products={bestSellers} onAdd={addToCart} />

        <CategorySection
          id="porti"
          eyebrow="Porti din aluminiu"
          title="Poarta care spune clar: aici e casa mea"
          description="Siguranță, intimitate și un design care impresionează — chiar de la intrare. Poarta ta spune prima poveste despre casă. Alege una din aluminiu, făcută să reziste și să arate ca-n revistă."
          ctaText="Descoperă colecția"
          ctaLink="#porti"
          banner="https://www.virtuoso.ro/image/cachewebp/catalog/Bannere/4-c-1888x590.webp"
          products={porti}
          onAdd={addToCart}
          viewAllLink="#porti"
          viewAllText="Vezi toate porțile"
        />

        <CategorySection
          id="porti-comanda"
          eyebrow="Porti la comanda"
          title="Seturi de porți la comandă - design unic, exclusiv"
          description="Modele exclusive de porți batante și pietonale la comandă. Aluminiu premium, WPC, sau combinații cu sticlă. Designuri inspirate din mitologia greacă: Ares, Atlas, Dionysos, Perseus, Atena și multe altele."
          products={portiLaComanda}
          onAdd={addToCart}
          viewAllLink="#porti-comanda"
          viewAllText="Vezi toate seturile"
        />

        <CategorySection
          id="garduri"
          eyebrow="Panouri gard din aluminiu"
          title="Gardul care spune clar: aici e casa mea"
          description="Siguranță, intimitate și un design care face impresie — începând din fața porții. Gardurile noastre nu-s doar panouri și stâlpi."
          ctaText="Descoperă colecția"
          ctaLink="#garduri"
          banner="https://www.virtuoso.ro/image/cachewebp/catalog/Bannere/2-c-1888x590.webp"
          products={garduri}
          onAdd={addToCart}
          viewAllLink="#garduri"
          viewAllText="Vezi toate panourile"
        />

        <ModularSection id="modulare" products={pieseModulare} onAdd={addToCart} />

        <CategorySection
          id="panouri-laser"
          eyebrow="Porti si gard laser fier forjat"
          title="Porți și garduri laser fier forjat"
          description="Lucrări realizate la comandă din tablă debitată laser CNC pe cadru de fier forjat. Modele moderne, geometrice, dezordine, dreptunghiuri suprapuse — sau trimite-ne propriul tău design. Preț 700 lei/m², ofertă finală în funcție de complexitate și dimensiuni."
          products={panouriLaser}
          onAdd={addToCart}
          viewAllLink="#panouri-laser"
          viewAllText="Vezi toate modelele"
          showCustomDesign={true}
        />

        <CategorySection
          id="feronerie"
          eyebrow="Feronerie"
          title="Kituri profesionale pentru porți"
          description="Sisteme complete de feronerie pentru porți batante, culisante și autoportante. Calitate profesională, montaj simplu, garanție extinsă."
          products={feronerie}
          onAdd={addToCart}
          viewAllLink="#feronerie"
          viewAllText="Vezi toate kiturile"
        />

        <CategorySection
          id="mobilier"
          eyebrow="Mobilier de gradina"
          title="Un pahar de vin. Un apus. Un set de mobilier care le leagă pe toate."
          description="Design care iese în evidență și rezistă ani de zile, nu doar un sezon. Când ai mobilierul potrivit, curtea ta devine locul preferat din toată casa."
          ctaText="Descoperă colecția"
          ctaLink="#mobilier"
          banner="https://www.virtuoso.ro/image/cachewebp/catalog/Bannere/Banner%20Homepage%20Virtuoso-p-1888x590.webp"
          products={mobilier}
          onAdd={addToCart}
          viewAllLink="#mobilier"
          viewAllText="Vezi toate colecțiile"
        />

        <CategorySection
          id="pergole"
          eyebrow="Pergole aluminiu"
          title="Pergole Deluxe cu Prindere pe Casă"
          description="Creează un spațiu de relaxare elegant și protejat, chiar lângă casă. Stil modern, protecție totală, zero întreținere."
          products={pergole}
          onAdd={addToCart}
          viewAllLink="#pergole"
          viewAllText="Vezi toate pergolele"
        />

        <CategorySection
          id="umbrele"
          eyebrow="Umbrele"
          title="Umbrele care se potrivesc cu orice produs"
          description="Ca un prieten mereu pregătit să te acopere! Aluminiu rezistent, design elegant, lumină LED opțională."
          products={umbrele}
          onAdd={addToCart}
          viewAllLink="#umbrele"
          viewAllText="Vezi toate umbrelele"
        />

        <CategorySection
          id="depozitare"
          eyebrow="Depozitare"
          title="Spații de depozitare premium"
          description="În cazul în care știi exact ce ai nevoie, poți cumpăra piesele componente și la bucată. Soluții moderne pentru curte și grădină."
          products={depozitare}
          onAdd={addToCart}
          viewAllLink="#depozitare"
          viewAllText="Vezi toate soluțiile"
        />

        <CategorySection
          id="decking"
          eyebrow="Decking"
          title="Decking-ul care transformă spațiul"
          description="Decking-ul nostru transformă orice spațiu exterior într-o oază modernă, unde relaxarea se îmbină cu stilul!"
          products={decking}
          onAdd={addToCart}
          viewAllLink="#decking"
          viewAllText="Vezi toate opțiunile"
        />

        {/* Portfolio */}
        <section id="portofoliu" className="py-16 md:py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12">
              <div className="text-amber-600 text-xs uppercase tracking-[0.3em] font-semibold mb-2">Portofoliu</div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                Lucrările noastre vorbesc pentru noi
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Te invităm să descoperi gama noastră de proiecte. Fă cea mai bună alegere pentru casa ta.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {portfolio.map((item) => (
                <a
                  key={item.id}
                  href="#"
                  className="group relative block aspect-[4/3] overflow-hidden rounded-sm bg-gray-200"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                    <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
                    <span className="inline-flex items-center gap-1 text-amber-400 text-sm">
                      Vezi proiectul <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </a>
              ))}
            </div>
            <div className="mt-10 text-center">
              <a
                href="#"
                className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-3 text-sm uppercase tracking-wide rounded-sm transition-colors"
              >
                Vezi toate lucrările
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        items={cart}
        onUpdateQty={updateQty}
        onRemove={removeFromCart}
        onClear={clearCart}
      />

      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
